import { defineMessages } from 'react-intl';

export default defineMessages({
    customerSince: {
        id: 'ml.gateway.views.account-detail.Customer Since',
        defaultMessage: 'CUSTOMER SINCE'
    },
    addNewQuote: {
        id: 'ml.gateway.views.account-detail.AddNewQuote',
        defaultMessage: 'ADD NEW QUOTE'
    },
    makeChanges: {
        id: 'ml.gateway.views.account-detail.MakeChanges',
        defaultMessage: 'MAKE CHANGES'
    },
    manageBundle: {
        id: 'ml.gateway.views.account-detail.ManageBundle',
        defaultMessage: 'Create / Manage Bundle'
    }
})